/**
 * useTicketThermalViewState — Estado compartido del toggle Web vs Térmica
 * (modo de vista + ancho de papel 58/80mm desde la config POS).
 *
 * QUÉ EXPORTA: useTicketThermalViewState, TicketViewMode (type)
 * QUÉ NO HACE: renderizado ni lógica de impresión.
 */
import { useState } from "react";
import { loadPosPrinterConfigFromStorage } from "@/lib/native/posPrinterConfig";

export type TicketViewMode = "web" | "thermal";

export function useTicketThermalViewState(defaultMode: TicketViewMode = "web") {
  const [viewMode, setViewMode] = useState(defaultMode);
  const [paperWidthMm, setPaperWidthMm] = useState<58 | 80>(
    () => loadPosPrinterConfigFromStorage().paperWidthMm,
  );
  return { viewMode, setViewMode, paperWidthMm, setPaperWidthMm };
}
